import { render, staticRenderFns } from "./ApplicationMenu.vue?vue&type=template&id=15213cd0&"
import script from "./ApplicationMenu.vue?vue&type=script&lang=js&"
export * from "./ApplicationMenu.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports